// hooks/billing/usePackages.js
import { useCallback, useEffect, useState } from 'react';
import BillingService from '../../services/billing.service';

/**
 * usePackages — public coin-package catalog (`GET /payments/packages`).
 *
 * Mirrors useTiers.js: normalizes to a plain array regardless of
 * whether the backend wraps it in `{items: [...]}` or returns a bare
 * array, since the exact response shape isn't confirmed yet.
 *
 * @param {Object} [options]
 * @param {boolean} [options.auto=true] auto-fetch on mount
 */
export function usePackages({ auto = true } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(auto);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    const result = await BillingService.listPackages();
    if (result.success) {
      const body = result.data;
      setData(Array.isArray(body) ? body : body?.items ?? []);
    } else {
      setError(result);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (auto) refetch();
  }, [auto, refetch]);

  return { data, loading, error, refetch };
}

export default usePackages;
